import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import DisponibilidadeCard from './components/DisponibilidadeCard';
import PageHeader from '@spark/ui-components/components/BreadCrumb';

const DisponibilidadeMain = () => {
  return <Container fluid>
      <Row>
        <Col md={12}>
          <PageHeader title="" routeSegments={[{
          name: 'Início'
        }, {
          name: 'Disponibilidade'
        }]} />
        </Col>
      </Row>
      
      <Row>
        <Col md={12}>
          <DisponibilidadeCard />
        </Col>
      </Row>
    </Container>;
};

export default DisponibilidadeMain;
